/**
 * У вбудованому браузері Telegram install PWA часто не спрацьовує.
 * Відкриваємо ту саму URL у системному браузері — UI не змінюється.
 */

export function isTelegramInApp() {
  if (typeof window === "undefined") return false;

  try {
    const ua = navigator.userAgent || "";
    if (/Telegram|TDMobile|TeleWebApp|tgWebApp|TelegramBot/i.test(ua)) {
      return true;
    }
    if (window.Telegram?.WebApp != null) {
      return true;
    }
    const ref = document.referrer || "";
    if (/t\.me|telegram\.(me|org|dog)/i.test(ref)) {
      return true;
    }
  } catch {
    return false;
  }

  return false;
}

export function isStandalonePwa() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.navigator.standalone === true
  );
}

export function isIosDevice() {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent || "");
}

const TG_PWA_SESSION_KEY = "tgPwaExternalOpenedOnce";

/**
 * У Telegram WebView: перше натискання в цій вкладці — відкрити Chrome/Safari
 * з тією ж URL; якщо користувач повернувся і натискає знову — false, щоб
 * спрацював звичайний pwaInstall у вбудованому браузері.
 * @returns {boolean} true якщо зробили редірект у зовнішній браузер (треба return)
 */
export function tryTelegramOpenExternalOnFirstTapOnly() {
  if (!isTelegramInApp() || isStandalonePwa()) {
    return false;
  }

  let isFirstTap = true;
  try {
    isFirstTap = sessionStorage.getItem(TG_PWA_SESSION_KEY) !== "1";
    if (isFirstTap) {
      sessionStorage.setItem(TG_PWA_SESSION_KEY, "1");
    }
  } catch {
    isFirstTap = true;
  }

  if (isFirstTap) {
    openCurrentSiteForPwaInstall();
    return true;
  }

  return false;
}

/**
 * @returns {boolean} true якщо спробували відкрити зовнішній браузер
 */
export function openCurrentSiteForPwaInstall() {
  if (typeof window === "undefined") return false;

  const ua = navigator.userAgent;
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const fullUrl = window.location.href.split("#")[0];
  const host = window.location.host;
  const pathQuery = `${window.location.pathname || "/"}${window.location.search || ""}`;

  if (isAndroid) {
    try {
      const intentUrl = `intent://${host}${pathQuery}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(fullUrl)};end`;
      const a = document.createElement("a");
      a.href = intentUrl;
      a.setAttribute("rel", "noopener");
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return true;
    } catch (_) {
      try {
        window.open(fullUrl, "_blank", "noopener,noreferrer");
        return true;
      } catch {
        return false;
      }
    }
  }

  if (isIOS) {
    try {
      window.open(fullUrl, "_blank", "noopener,noreferrer");
      return true;
    } catch {
      return false;
    }
  }

  try {
    window.open(fullUrl, "_blank", "noopener,noreferrer");
    return true;
  } catch {
    return false;
  }
}
